import React from 'react'
import { Align, Marker } from 'react-native-nmap'
import { Place } from 'infra/type'
import { PLACE_MARKER_IMAGE } from 'image'
import { MapStore } from 'store/map'
import { observer } from 'mobx-react'
import { getCategoryMarkerImage } from 'image/marker'

const RATIO = 1.2
const SELECTED_RATIO = 1.5

const getMarkerImage = (place: Place) => {
  if (!place.categories?.length) {
    return PLACE_MARKER_IMAGE
  }
  const markerImage = getCategoryMarkerImage(
    place.categories[0],
    place.preference === 'AVOID',
  )
  return markerImage || PLACE_MARKER_IMAGE
}

export const formatPlaceText = (place: Place, hidePreference?: boolean) => {
  if (hidePreference || !place.preference) return place.name
  // 아예 타이틀 보여주지 말기
  if (place.preference === 'AVOID') return ''
  return `${place.name} ${
    {
      WANT: '🚩',
      LIKED: '❤️',
    }[place.preference]
  }`
}

export const PlaceMarker: React.FC<{
  place: Place
  mapStore?: MapStore
  hidePreference?: boolean
}> = observer(({ place, mapStore, hidePreference }) => {
  const ratio = !(mapStore?.selectedPlace?.id === place.id)
    ? RATIO
    : SELECTED_RATIO
  const markerImage = getMarkerImage(place)
  return (
    <Marker
      coordinate={{
        latitude: Number(place.coord.lat),
        longitude: Number(place.coord.lng),
      }}
      caption={
        mapStore?.isZoomMini
          ? {}
          : {
              text: formatPlaceText(place, hidePreference),
              align: Align.Top,
              offset: 2,
            }
      }
      image={markerImage}
      width={20 * ratio}
      height={20 * ratio}
      onClick={() => mapStore?.selectPlace(place)}
    />
  )
})
